import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMappedModel from "../../helpers/JsonMappedModel";
import StoreLayoutI18nCollection from "@/assets/js/models/store/storeLayout/StoreLayoutI18nCollection";
import StoreLayoutI18n from "@/assets/js/models/store/storeLayout/StoreLayoutI18n";
import Store from "@/assets/js/models/domain/Store";
var _attributes = /*#__PURE__*/new WeakMap();
export default class StoreLayout extends JsonMappedModel {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [StoreLayout.id_attribute_name]: null,
      [StoreLayout.name_attribute_name]: null,
      [StoreLayout.store_attribute_name]: Store,
      [StoreLayout.store_layout_i18ns_attribute_name]: StoreLayoutI18nCollection
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getNameAttributeName() {
    return this.name_attribute_name;
  }
  static getBlocksAttributeName() {
    return this.blocks_attribute_name;
  }
  static getStoreLayoutI18nsAttributeName() {
    return this.store_layout_i18ns_attribute_name;
  }
  static getStoreAttributeName() {
    return this.store_attribute_name;
  }
  getStore() {
    return this.getAttribute(StoreLayout.store_attribute_name);
  }
  getName() {
    return this.getAttribute(StoreLayout.getNameAttributeName());
  }
  getI18ns() {
    var _this$getAttribute;
    return (_this$getAttribute = this.getAttribute(StoreLayout.getStoreLayoutI18nsAttributeName())) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : [];
  }
  getI18nBlocks(language) {
    const i18ns = this.getI18ns();
    if (!Array.isArray(i18ns)) {
      return [];
    }
    const i18n = i18ns.find(i18n => i18n instanceof StoreLayoutI18n && i18n.getLanguage() === language);
    return i18n instanceof StoreLayoutI18n ? i18n.getBlocks() : [];
  }
  getBlocks(language) {
    var _language;
    language = (_language = language) !== null && _language !== void 0 ? _language : 'en';
    let i18nBlocks = this.getI18nBlocks();
    return i18nBlocks[language];
  }
  getLink() {
    const store = this.getStore();
    return store instanceof Store ? store.getLink() : null;
  }
}
_defineProperty(StoreLayout, "id_attribute_name", 'id');
_defineProperty(StoreLayout, "name_attribute_name", 'name');
_defineProperty(StoreLayout, "blocks_attribute_name", 'blocks');
_defineProperty(StoreLayout, "store_layout_i18ns_attribute_name", 'store_layout_i18ns');
_defineProperty(StoreLayout, "store_attribute_name", 'store');